import Vue from "vue";
import Vuex from "vuex";
import login from "./Login/index";
import Product from "./Product";
import UserManage from "./UserManage";
import ExtenSion from "./Extension";
import Income from "./Income";
import Summary from "./Summary";
import SummaryTest from "./Summary/index_test.js";
import Allreport from "./Allreport";
import RolePower from "./RolePower";
import ParamSetting from "./Paramsetting";
import Promotion from "./Promotion";
import PromotionTtV2 from "./Promotion-ttV2";
import PromotionKuaishou from "./Promotion-kuaishou";
import PromotionGdt from "./Promotion-gdt";
import PromotionGoogle from "./Promotion-google";
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    login,
    Product,
    UserManage,
    ExtenSion,
    Income,
    Summary,
    SummaryTest,
    Allreport,
    RolePower,
    ParamSetting,
    Promotion,
    PromotionKuaishou,
    PromotionGdt,
    PromotionTtV2,
    PromotionGoogle,
  },
});
